import { Brain, MapPin, Settings2, Images, Sparkles } from "lucide-react";
import type { POICategory } from "./types";

export const STEPS = [
  { label: "Diagnóstico", icon: Brain },
  { label: "Localização", icon: MapPin },
  { label: "Ajustes", icon: Settings2 },
  { label: "Imagens", icon: Images },
  { label: "Proposta", icon: Sparkles },
] as const;

export const DEFAULT_MAP_CENTER = { lat: -23.5505, lng: -46.6333 };

export const POI_COLOR_MAP: Record<POICategory, string> = {
  restaurant: "#EF4444",
  cafe: "#92400E",
  pharmacy: "#22C55E",
  transport: "#3B82F6",
  hotel: "#8B5CF6",
  parking: "#6B7280",
};

export const DIAGNOSIS_INSIGHTS: string[] = [
  "Custo por posição atual está dentro da média. Foque na proposta de valor e flexibilidade.",
  "Modelo CAPEX atual indica oportunidade de migração para OPEX com ganho de flexibilidade e redução de imobilização de capital.",
  "Volume de posições qualifica para desconto enterprise. Considere contrato de 18-24 meses para maximizar benefício.",
];

export const PLATFORM_STATS: { value: string; label: string }[] = [
  { value: "+2.000", label: "Coworkings" },
  { value: "+11.000", label: "Estações" },
  { value: "+300", label: "Cidades" },
  { value: "6", label: "Países" },
];

export const POI_CATEGORIES: { value: POICategory; label: string }[] = [
  { value: "restaurant", label: "Restaurantes" },
  { value: "cafe", label: "Cafés" },
  { value: "pharmacy", label: "Farmácias" },
  { value: "transport", label: "Transporte" },
  { value: "hotel", label: "Hotéis" },
  { value: "parking", label: "Estacionamentos" },
];
